import React from "react";
import { Badge } from "../ui/badge";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";

export function EmployeeFormTabs({
  formData,
  setFormData,
  skills,
  technologies,
  toggleSkill,
  toggleTech,
  t,
  isSpanish,
}) {
  return (
    <Tabs defaultValue="personal" className="w-full">
      <TabsList className="flex h-auto flex-wrap bg-[#0B0E14] border border-[#242E42]">
        <TabsTrigger value="personal" className="data-[state=active]:bg-[#E2B05E] data-[state=active]:text-[#0B0E14]">
          Personal
        </TabsTrigger>
        <TabsTrigger value="work" className="data-[state=active]:bg-[#E2B05E] data-[state=active]:text-[#0B0E14]">
          Laboral
        </TabsTrigger>
        <TabsTrigger value="skills" className="data-[state=active]:bg-[#E2B05E] data-[state=active]:text-[#0B0E14]">
          Skills
        </TabsTrigger>
        <TabsTrigger value="payment" className="data-[state=active]:bg-[#E2B05E] data-[state=active]:text-[#0B0E14]">
          Pago
        </TabsTrigger>
      </TabsList>

      <TabsContent value="personal" className="space-y-4 mt-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("firstName")}</Label>
            <Input
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="valhalla-input"
              required
              data-testid="emp-name"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("lastName")}</Label>
            <Input
              value={formData.last_name}
              onChange={(e) =>
                setFormData({ ...formData, last_name: e.target.value })
              }
              className="valhalla-input"
              required
              data-testid="emp-lastname"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("email")}</Label>
          <Input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="valhalla-input"
            required
            data-testid="emp-email"
          />
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("phone")}</Label>
            <Input
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="valhalla-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("documentId")}</Label>
            <Input
              value={formData.document_id}
              onChange={(e) =>
                setFormData({ ...formData, document_id: e.target.value })
              }
              className="valhalla-input"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("address")}</Label>
          <Input
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            className="valhalla-input"
          />
        </div>
      </TabsContent>

      <TabsContent value="work" className="space-y-4 mt-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("position")}</Label>
            <Input
              value={formData.position}
              onChange={(e) =>
                setFormData({ ...formData, position: e.target.value })
              }
              className="valhalla-input"
              required
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("department")}</Label>
            <Input
              value={formData.department}
              onChange={(e) =>
                setFormData({ ...formData, department: e.target.value })
              }
              className="valhalla-input"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{isSpanish ? "Equipo" : "Team"}</Label>
          <Select
            value={formData.team}
            onValueChange={(v) => setFormData({ ...formData, team: v })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="desarrollo">Desarrollo</SelectItem>
              <SelectItem value="diseno">Diseno</SelectItem>
              <SelectItem value="qa">QA</SelectItem>
              <SelectItem value="marketing">Marketing</SelectItem>
              <SelectItem value="ventas">Ventas</SelectItem>
              <SelectItem value="administrativo">Administrativo</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("hireDate")}</Label>
            <Input
              type="date"
              value={formData.hire_date}
              onChange={(e) =>
                setFormData({ ...formData, hire_date: e.target.value })
              }
              className="valhalla-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("status")}</Label>
            <Select
              value={formData.status}
              onValueChange={(v) => setFormData({ ...formData, status: v })}
            >
              <SelectTrigger className="valhalla-input">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#151B26] border-[#242E42]">
                <SelectItem value="activo">{t("active")}</SelectItem>
                <SelectItem value="inactivo">{t("inactive")}</SelectItem>
                <SelectItem value="suspendido">Suspendido</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("modality")}</Label>
            <Select
              value={formData.modality}
              onValueChange={(v) => setFormData({ ...formData, modality: v })}
            >
              <SelectTrigger className="valhalla-input">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#151B26] border-[#242E42]">
                <SelectItem value="tiempo_completo">{t("fullTime")}</SelectItem>
                <SelectItem value="medio_tiempo">{t("partTime")}</SelectItem>
                <SelectItem value="contratista">{t("contractor")}</SelectItem>
                <SelectItem value="freelancer">{t("freelancer")}</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("level")}</Label>
            <Select
              value={formData.level}
              onValueChange={(v) => setFormData({ ...formData, level: v })}
            >
              <SelectTrigger className="valhalla-input">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#151B26] border-[#242E42]">
                <SelectItem value="junior">{t("junior")}</SelectItem>
                <SelectItem value="semi_senior">{t("semiSenior")}</SelectItem>
                <SelectItem value="senior">{t("senior")}</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("weeklyCapacity")} (hrs)</Label>
          <Input
            type="number"
            value={formData.weekly_capacity}
            onChange={(e) =>
              setFormData({
                ...formData,
                weekly_capacity: parseInt(e.target.value, 10) || 40,
              })
            }
            className="valhalla-input"
          />
        </div>
      </TabsContent>

      <TabsContent value="skills" className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("skills")}</Label>
          <div className="flex flex-wrap gap-2">
            {skills.map((skill) => (
              <Badge
                key={skill}
                variant="outline"
                className={`cursor-pointer transition-all ${
                  formData.skills.includes(skill)
                    ? "bg-[#E2B05E]/20 border-[#E2B05E] text-[#E2B05E]"
                    : "border-[#242E42] text-[#9CA3AF] hover:border-[#3AB8D6]"
                }`}
                onClick={() => toggleSkill(skill)}
              >
                {skill}
              </Badge>
            ))}
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("technologies")}</Label>
          <div className="flex flex-wrap gap-2">
            {technologies.map((tech) => (
              <Badge
                key={tech}
                variant="outline"
                className={`cursor-pointer transition-all ${
                  formData.technologies.includes(tech)
                    ? "bg-[#3AB8D6]/20 border-[#3AB8D6] text-[#3AB8D6]"
                    : "border-[#242E42] text-[#9CA3AF] hover:border-[#3AB8D6]"
                }`}
                onClick={() => toggleTech(tech)}
              >
                {tech}
              </Badge>
            ))}
          </div>
        </div>
      </TabsContent>

      <TabsContent value="payment" className="space-y-4 mt-4">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("paymentType")}</Label>
          <Select
            value={formData.payment_type}
            onValueChange={(v) => setFormData({ ...formData, payment_type: v })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="salario_fijo">{t("fixedSalary")}</SelectItem>
              <SelectItem value="pago_hora">{t("hourlyPayment")}</SelectItem>
              <SelectItem value="pago_tarea">{t("taskPayment")}</SelectItem>
              <SelectItem value="hibrido">{t("hybrid")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("internalCost")} ($/mes)</Label>
            <Input
              type="number"
              value={formData.internal_cost}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  internal_cost: parseFloat(e.target.value) || 0,
                })
              }
              className="valhalla-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-[#9CA3AF]">{t("hourlyRate")} ($/hr)</Label>
            <Input
              type="number"
              value={formData.hourly_rate}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  hourly_rate: parseFloat(e.target.value) || 0,
                })
              }
              className="valhalla-input"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("bankInfo")}</Label>
          <Input
            value={formData.bank_info}
            onChange={(e) =>
              setFormData({ ...formData, bank_info: e.target.value })
            }
            className="valhalla-input"
            placeholder="Bank account details"
          />
        </div>
      </TabsContent>
    </Tabs>
  );
}
